import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';
import config from '../../../data/SiteConfig';

const NavStyles = styled.nav`
  background-color: var(--brand);
  padding: 0 15px;
  border-radius: 4px;
  color: #fff;
  font-size: 1.8rem;
  position: sticky;
  top: 0;
  height: 50px;
  z-index: 99;
  box-shadow: 0 0 5px 3px rgba(0, 0, 0, 0.044);

  .logo-item {
    width: 4rem;
    background: #fff;
    border: 1px solid var(--brand);
    img {
      object-fit: contain;
      width: 100%;
    }
  }
  ul {
    height: 100%;
    display: flex;
    align-items: center;
  }
  li {
    display: flex;
    align-items: center;
    position: relative;
    padding: 8px;
    &:hover {
      > a {
        color: var(--yellow);
      }
      .sub-menu {
        display: flex;
      }
    }
  }

  a {
    font-size: 1.5rem;
    text-decoration: none;
    display: block;
    color: #fff;
  }

  .sub-menu {
    position: absolute;
    top: 100%;
    min-width: 150px;
    background-color: var(--brand);
    padding: 25px 5px;
    border-radius: 0 0 4px 4px;
    display: none;
  }

  .last-item {
    margin-inline-start: auto;
  }
`;

export default function Nav({ navData }) {
  return (
    <NavStyles>
      <ul>
        <li className='logo-item'>
          <Link to='/'>
            <img src='/logos/logo.png' alt={config.siteTitle} />
          </Link>
        </li>
        {navData.map((item) => (
          <li key={item.slug}>
            <Link to={`/${item.slug}`}>{item.title}</Link>
            {item.children && item.children.length ? (
              <ul className='sub-menu'>
                {item.children.map((childItem) => (
                  <li key={childItem.slug}>
                    <Link to={`/${item.slug}/${childItem.slug}`}>
                      {childItem.title}
                    </Link>
                  </li>
                ))}
              </ul>
            ) : null}
          </li>
        ))}
        <li className='last-item'>
          <a href='/blog'>المدونة</a>
        </li>
      </ul>
    </NavStyles>
  );
}
